import React from 'react';
import classNames from 'classnames';

const InputField = ({ children, className, ...props }) => {
  const id = `${props.name}-${props.value}`;
  return (
    <label
      htmlFor={id}
      className={classNames(
        'InputField-label',
        className,
        props.pendoClassName,
      )}
    >
      <input {...props} id={id} className="InputField-input" tabIndex="0" />
      <span className="InputField-labelText">{children}</span>
    </label>
  );
};

export default InputField;
